import React, { useEffect } from 'react';
import { Link, Table, TableColumn } from '@backstage/core-components';
import { ComponentVersion } from '@internal/backstage-plugin-bidone-backend';
import LoadingIcon from '@mui/material/CircularProgress';
import TickIcon from '@mui/icons-material/WorkspacePremium';
import Tooltip from '@mui/material/Tooltip';
import { EnvTagsListComponent } from './EnvTagsList';

interface Props {
  loading?: boolean;
  tagLoading?: boolean;
  versions: Record<string, ComponentVersion>;
  env: string;
  allLoading?: boolean;
}

const renderNameCell = ({ entityRef, name, type }: ComponentVersion) => {
  if (!entityRef) {
    return name;
  }

  const actualName =
    type.indexOf('microsoft') !== 0 ? `${name} (non-Azure)` : name;

  return (
    <>
      <Link to={`/catalog/${entityRef}`}>{actualName}</Link>
      <Tooltip
        title="This component is enrolled in the Dev Portal"
        placement="top"
      >
        <TickIcon color="success" fontSize="small" />
      </Tooltip>
    </>
  );
};

export const VersionTableComponent: React.FC<Props> = ({
  versions,
  loading,
  tagLoading,
  env,
  allLoading,
}: Props) => {
  // Hack: to fix the horizontal scroll issue
  useEffect(() => {
    const el = document.querySelector('[class*="horizontalScrollContainer"]');
    if (el) {
      (el as HTMLElement).style.position = 'initial';
    }
  }, []);

  const columns: TableColumn<ComponentVersion>[] = [
    {
      title: 'Name',
      field: 'name',
      render: renderNameCell,
      width: '15%',
    },
    {
      title: 'Bitbucket Tag',
      field: 'bitbucketTag',
      render: ({ bitbucketTag }: ComponentVersion) =>
        tagLoading ? (
          <LoadingIcon size={20} />
        ) : (
          bitbucketTag && bitbucketTag[env]
        ),
      width: '10%',
    },
    {
      title: 'Azure Tags',
      render: ({ azureTags }: ComponentVersion) => (
        <EnvTagsListComponent tags={azureTags} />
      ),
    },
  ];

  return (
    <Table
      isLoading={loading}
      title={
        <>
          <span>Version Checker&nbsp;</span>
          {allLoading && <LoadingIcon size={20} />}
        </>
      }
      options={{ paging: false, thirdSortClick: false }}
      columns={columns}
      data={Object.values(versions)}
    />
  );
};
